import { PLACEHOLDER_MINIMUM_USDC_PRICE } from '@components/Web3/CreateTownWithDuration/createTownWithDuration.schema'
import { gatingSchema } from '@components/Web3/Gating/Gating.schema'
import { z } from 'zod'

import { DEFAULT_MEMBERSHIP_LIMIT } from './defaultMembershipLimit'

const usdcPricingErrorMessage = 'Please choose how you want to set the price of your membership.'

export const membershipLimitSchemaUsdc = z.coerce
    .number({ message: 'Please enter a number' })
    .min(1, { message: 'Please enter a number greater than 0' })
    .max(DEFAULT_MEMBERSHIP_LIMIT, {
        message: `Please enter a number less than or equal to ${DEFAULT_MEMBERSHIP_LIMIT.toLocaleString()}`,
    })

export const editMembershipSchemaUsdc = z
    .object({
        membershipCurrency: z.string(),
        membershipLimit: membershipLimitSchemaUsdc,
        usdcPricingOption: z.union([
            z.literal('free', {
                errorMap: () => ({ message: usdcPricingErrorMessage }),
            }),
            z.literal('fixed', {
                errorMap: () => ({ message: usdcPricingErrorMessage }),
            }),
        ]),
        membershipCostUsdc: z.string(),
    })
    .and(gatingSchema)
    .superRefine((data, ctx) => {
        const membershipCostAsNumber = Number(data['membershipCostUsdc'])
        const isFixedPricing = data['usdcPricingOption'] === 'fixed'
        const minimumPrice = Number(PLACEHOLDER_MINIMUM_USDC_PRICE)

        if (isFixedPricing) {
            if (isNaN(membershipCostAsNumber)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Please enter a valid number.',
                    path: ['membershipCostUsdc'],
                })
            } else if (membershipCostAsNumber < minimumPrice) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `Minimum price is ${PLACEHOLDER_MINIMUM_USDC_PRICE} USDC`,
                    path: ['membershipCostUsdc'],
                })
            }
        }
    })

export type EditMembershipSchemaUsdcType = z.infer<typeof editMembershipSchemaUsdc>
